import React from 'react';
import { useAppMessage } from '@providers'
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {RoutesFields} from '@constants';
import {
    AgendamentoPage,
    FinalizarAgendamentoPage,
    FollowUpPage,
    Home,
    PreAgendamentoPage,
    RelatorioFornecedor,
    RelatorioTrasportadora
} from '@pages';
import {RouteWrapper} from './RouteWrapper';

const ROLE_REDIRECT_MESSAGE =
    'Você não possui permissão de acesso à essa página, por favor contate o administrador da conta.';

export const DiferpanRoutes = () => {
    const message = useAppMessage();
    const location = useLocation();
    const isRolesRedirect = location.state?.unauthorized;
    if (isRolesRedirect) {
        message.error(ROLE_REDIRECT_MESSAGE);
    }


    return (
        <main>
            <Routes>
                <Route
                    path={RoutesFields.HOME.PATH}
                    element={
                        <RouteWrapper
                            permissions={RoutesFields.HOME.PERMISSIONS}
                            headerTitle={RoutesFields.HOME.TITLE}
                            component={Home}
                            isPublic={true}
                        />
                    }
                />
                <Route
                    path={RoutesFields.RELATORIO_TRASPORTADORA.PATH}
                    element={
                        <RouteWrapper
                            permissions={RoutesFields.RELATORIO_TRASPORTADORA.PERMISSIONS}
                            headerTitle={RoutesFields.RELATORIO_TRASPORTADORA.TITLE}
                            component={RelatorioTrasportadora}
                            page={RoutesFields.RELATORIO_TRASPORTADORA.TITLE}
                            path={RoutesFields.RELATORIO_TRASPORTADORA.PATH}
                        />
                    }
                />
                <Route
                    path={RoutesFields.RELATORIO_FORNECEDOR.PATH}
                    element={
                        <RouteWrapper
                            permissions={RoutesFields.RELATORIO_FORNECEDOR.PERMISSIONS}
                            headerTitle={RoutesFields.RELATORIO_FORNECEDOR.TITLE}
                            component={RelatorioFornecedor}
                            page={RoutesFields.RELATORIO_FORNECEDOR.TITLE}
                            path={RoutesFields.RELATORIO_FORNECEDOR.PATH}
                        />
                    }
                />
                <Route
                    path={RoutesFields.FOLLOW_UP.PATH}
                    element={
                        <RouteWrapper
                            permissions={RoutesFields.FOLLOW_UP.PERMISSIONS}
                            headerTitle={RoutesFields.FOLLOW_UP.TITLE}
                            component={FollowUpPage}
                            page={RoutesFields.FOLLOW_UP.TITLE}
                            path={RoutesFields.FOLLOW_UP.PATH}
                        />
                    }
                />
                <Route
                    path={RoutesFields.REGISTRATION_AGENDA.PATH}
                    element={
                        <RouteWrapper
                            permissions={RoutesFields.REGISTRATION_AGENDA.PERMISSIONS}
                            headerTitle={RoutesFields.REGISTRATION_AGENDA.TITLE}
                            component={AgendamentoPage}
                            page={RoutesFields.REGISTRATION_AGENDA.TITLE}
                            path={RoutesFields.REGISTRATION_AGENDA.PATH}
                        />
                    }
                />
                <Route
                    path={RoutesFields.REGISTRATION_PRE_AGENDA.PATH}
                    element={
                        <RouteWrapper
                            permissions={RoutesFields.REGISTRATION_PRE_AGENDA.PERMISSIONS}
                            headerTitle={RoutesFields.REGISTRATION_PRE_AGENDA.TITLE}
                            component={PreAgendamentoPage}
                            page={RoutesFields.REGISTRATION_PRE_AGENDA.TITLE}
                            path={RoutesFields.REGISTRATION_PRE_AGENDA.PATH}
                        />
                    }
                />
                <Route
                    path={RoutesFields.REGISTRATION_PRE_AGENDA_FINALIZE.PATH}
                    element={
                        <RouteWrapper
                            permissions={RoutesFields.REGISTRATION_PRE_AGENDA_FINALIZE.PERMISSIONS}
                            headerTitle={RoutesFields.REGISTRATION_PRE_AGENDA_FINALIZE.TITLE}
                            component={FinalizarAgendamentoPage}
                            page={RoutesFields.REGISTRATION_PRE_AGENDA_FINALIZE.TITLE}
                            path={RoutesFields.REGISTRATION_PRE_AGENDA_FINALIZE.PATH}
                        />
                    }
                />
                <Route path="*" element={<Navigate to={RoutesFields.HOME.PATH} replace/>}/>
            </Routes>
        </main>
    );
};
